import { render, staticRenderFns } from "./_followUs.vue?vue&type=template&id=e5adb2e6&lang=pug&"
import script from "./_followUs.vue?vue&type=script&lang=js&"
export * from "./_followUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports